import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const TrustedBy = () => {
  const logos = [
    {
      name: "NRB",
      imageUrl:
        "https://upload.wikimedia.org/wikipedia/commons/9/9e/Seal_of_the_Nepal_Rastra_Bank.jpg",
    },
    {
      name: "Coca-Cola",
      imageUrl:
        "https://i.pinimg.com/736x/1e/c1/d2/1ec1d2ce366d1f603b1bde70ae508063.jpg",
    },
    {
      name: "DCGF",
      imageUrl:
        "https://dcgf.gov.np/front/nep/images/deposit-and-credit-guarantee-fund-small-logo.jpg",
    },
    {
      name: "NIC",
      imageUrl:
        "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/a7/5c/7a/a75c7aa6-af62-cca0-6117-02d8ac4435b0/AppIcon-0-0-1x_U007emarketing-0-6-0-0-85-220.png/512x512bb.jpg",
    },
    {
      name: "Indian EMB",
      imageUrl:
        "https://www.indembkathmandu.gov.in/themes/w3cms/embassy-of-india/assets/images/logo.png",
    },
    {
      name: "Deprosc",
      imageUrl:
        "https://cdn.arthakendra.com/sharehub/images/2024/09/06/044726-ddbl-logo.png",
    },
    {
      name: "Mahuli",
      imageUrl: "https://mslbsl.com.np/images/logo.png",
    },
    {
      name: "Forward",
      imageUrl:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTc_l28eISorl_lFtoi8_-Nf0QtOifrATEtgNjjBVVv6Mo6s0PCz_PO6H8B4oYWHsYI38Y&usqp=CAU",
    },
    {
      name: "SWBBL",
      imageUrl:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRMlTCw_BO35RqD9Hli4VvOP6PHdaBNmTQDSw&s",
    },
    {
      name: "BGMCL",
      imageUrl:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQiC3m-iweVix1tspYKYLq-mnU09F3KcQ_WcQ&s",
    },
    {
      name: "Gurans",
      imageUrl:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTnhUZ8f3yuWmWybgcCL13iA-87Bwm-NpKGxw&s",
    },
    {
      name: "SKBBL",
      imageUrl:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTbZu2roQgmSA8qaXCUaFQ5SD1i2Pb0R0Igvg&s",
    },
    {
      name: "NMB",
      otherEffects: "rounded-full",
      imageUrl:
        "https://play-lh.googleusercontent.com/g4X-bVwFmeY32A4KfP35vZFQwVSu99qacIUDzi1Y2jKYsQi7t-Wkjb9fvaUWBOVgepwo",
    },
  ];

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1024 },
      items: 6,
    },
    desktop: {
      breakpoint: { max: 1024, min: 768 },
      items: 6,
    },
    tablet: {
      breakpoint: { max: 768, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
    },
  };

  return (
    <div className="mb-10">
      <h1 className="font-semibold text-primary text-xl md:text-2xl  lg:text-3xl text-center mb-2">
        We are Trusted By
      </h1>
      <p className="text-center text-gray-600 text-sm sm:text-base md:text-lg mb-2">
        Our clients and partners include some of the most trusted brands.
      </p>
      <div className="max-w-full mx-auto">
        <Carousel
          responsive={responsive}
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={2000}
          arrows={false}
          className="relative"
          containerClass="carousel-container px-0"
        >
          {logos.map((logo, index) => (
            <div key={index} className="flex items-center justify-center p-2">
              <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow p-4 flex items-center justify-center w-24 h-24 md:w-28 md:h-28 lg:w-32 lg:h-32">
                <img
                  src={logo.imageUrl}
                  alt={logo.name}
                  className={`max-h-full max-w-full object-contain ${logo.otherEffects} `}
                />
              </div>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default TrustedBy;
